/**
 * @generated by @interxfi/j5-codegen (Plugin: NormalizedQueryPlugin) - do not edit */

import type { IxcSweepsClearingV1SweepsTaskEvent } from '@interxfi/types';
import { schema } from 'normalizr';

export const IXC_SWEEPS_CLEARING_V1_SWEEPS_TASK_EVENT_ENTITY_NAME = 'ixc.sweeps.clearing.v1.SweepsTaskEvent';
export const ixcSweepsClearingV1SweepsTaskEventEntity = new schema.Entity<IxcSweepsClearingV1SweepsTaskEvent>(IXC_SWEEPS_CLEARING_V1_SWEEPS_TASK_EVENT_ENTITY_NAME, {}, { idAttribute: (entity: IxcSweepsClearingV1SweepsTaskEvent) => `${entity.metadata?.eventId}` });

